import React from 'react';

import { latexParser } from '../../../utilities/utilities';

import classes from './Event.module.scss';

const Event = props => {
    const controlTime = new Date();
    // const timeZone = controlTime.getTimezoneOffset()/60;
    const time = props.day && props.hour ? <div><span className={classes.TalkTime}>Talk time:</span> {props.day}, {props.hour} CET (UTC+1:00)</div> : null;
    const eventTime = new Date(time);


    const abstractModalContent = {
        title: latexParser(`${props.title} (${props.name})`),
        body: latexParser(props.abstract)
    }

    const showAbstractHandler = () => {
        props.setModalContent(abstractModalContent);
        props.showModal(true);
    }

    const roomInfo = <div className={classes.RoomInfo}>
        <span className={classes.TalkTime}>Room: </span>
        <a
            className={classes.RoomLink}
            href={props.link}
            target='_blank'
            rel='noreferrer noopener'>{props.room ? props.room : null}</a>
    </div>

    return <div className={classes.Event}>
        <div className={classes.Title} onClick={showAbstractHandler}>
            {props.title ? latexParser(props.title) : 'To be announced'}
        </div>
        <div className={classes.Author}>{props.name}, {props.affiliation}</div>
        <div className={classes.TalkTime}>{time ? time : 'Not set yet'}</div>
        {props.auth && roomInfo}
    </div>
}

export default Event;